

export const GlobalMonitorParameterFuncType = {
    
    /**
     * 倾斜双目
     */
    TILT_BOTH_EYES: 1,
    /**
     * 平行双目
     */
    PARALLEL_BINOCULAR: 2,
}